import { render, staticRenderFns } from "./CsuSummary.vue?vue&type=template&id=4d8947e5&scoped=true&"
import script from "./CsuSummary.vue?vue&type=script&lang=js&"
export * from "./CsuSummary.vue?vue&type=script&lang=js&"
import style0 from "./CsuSummary.vue?vue&type=style&index=0&id=4d8947e5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8947e5",
  null
  
)

export default component.exports